module.exports = __webpack_public_path__ + "static/media/aplicacao.d07f6a17.jpg";